import IconButton from '@components/v2/ui/IconButton/IconButton';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { Plus } from 'lucide-react';
import { ChangeEvent, useRef } from 'react';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../translation/TranslationContext';
import { RACHEL_FILE_ALLOWED_MEDIA_TYPES } from '../../../../rachel.files';

interface RachelInputAttachButtonProps {
  isVisible: boolean;
  className: string;
  onAttachFiles: (files: File[]) => void;
}

const RachelInputAttachButton = ({
  isVisible,
  className,
  onAttachFiles,
}: RachelInputAttachButtonProps) => {
  const { translate } = useTranslation();
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleFileInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      onAttachFiles(Array.from(event.target.files));
    }
    event.target.value = '';
  };

  const attachLabel = translate(LangEnum.RACHEL_INPUT_ATTACH);

  return (
    <>
      {isVisible && (
        <Tooltip placement="top" TooltipContent={attachLabel} tabIndex={-1}>
          <IconButton
            icon={Plus}
            className={className}
            ariaLabel={attachLabel}
            onClick={() => fileInputRef.current?.click()}
          />
        </Tooltip>
      )}
      <input
        ref={fileInputRef}
        type="file"
        multiple
        hidden
        accept={RACHEL_FILE_ALLOWED_MEDIA_TYPES.join(',')}
        onChange={handleFileInputChange}
      />
    </>
  );
};

export default RachelInputAttachButton;
